import { render, staticRenderFns } from "./viewBox.vue?vue&type=template&id=b7a9b05c"
import script from "./viewBox.vue?vue&type=script&lang=js"
export * from "./viewBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports